<template>
<v-menu
    ref="menu"
    v-model="menu"
    :nudge-right="40"
    :return-value.sync="itemValue"
    lazy
    transition="scale-transition"
    offset-y
    full-width
    min-width="290px"
  >
    <v-text-field
      slot="activator"
      v-model="dateFormatted"
      :label="item.label"
      :disabled="item.disabled || false"
      :rules="item.rules || []"
      :required="item.required || false"
      :placeholder="item.placeholder || undefined"
      prepend-icon=""
      readonly
      @blur="dateFormatted = parseDate(dateFormatted)"
    ></v-text-field>
    <v-date-picker
      v-show="!item.disabled"
      :color="item.color || 'primary'"
      locale="es" v-model="itemValue" @input="$refs.menu.save(itemValue)"></v-date-picker>

  </v-menu>
</template>

<script>

'use strict'

export default {

  name: 'VuetifyDatePicker',
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    item: {
      type: Object,
      default: null,
      required: true
    },
    value: {
      default: null
    }
  },

  data: () => ({
    itemValue: '',
    menu: false,
    dateFormatted: null
  }),

  created () {
    this.itemValue = this.item.value
  },

  computed: {
    computedDateFormatted () {
      return this.formatDate(this.itemValue)
    }
  },

  watch: {
    itemValue: {
      handler: function (val, oldVal) {
        console.log(val)
        this.dateFormatted = this.formatDate(this.itemValue)
        this.$emit('on-change', this.itemValue, oldVal, this.item, true)
      },
      deep: true
    },
    value: {
      handler: function (val, oldVal) {
        this.itemValue = val
        this.$emit('on-change', val, oldVal, this.item, true)
      },
      deep: true
    }
  },

  methods: {
    formatDate (date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}-${month}-${year}`
    },
    parseDate (date) {
      if (!date) return null

      // const [month, day, year] = date.split('-')
      // return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
      const [day, month, year] = date.split('-')
      return `${day}-${month}-${year}`
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/vuetify-form-creator/fields/vuetify-date-picker.vue